import React from 'react';

import { flagStyles } from '../settings';

const SvgTT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5352px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTT;
